import { Injector, Pipe, PipeTransform } from '@angular/core';
import { AppComponentBase } from '@app/app-component.base';

@Pipe({
    name: 'localize'
})
export class LocalizePipe extends AppComponentBase implements PipeTransform {
    
    constructor(injector: Injector) {
        super(injector);
    }

    transform(key: string, args: any[]): string {
        if (args && args.length > 0) {
            args.forEach((element, index) => {
                args[index] = this.l(element);
            });
        }
        return this.l(key, args);
    }
}
